module.exports = __webpack_public_path__ + "static/img/qq.39d17f22.png";